export const Title = ({ title }) => {
    return (
        <h1 className="font-bold text-2xl text-slate-900 flex justify-center">
            {title}
        </h1>
    );
};
